module.exports = __webpack_public_path__ + "img/podium_2024.2b93ce37.jpg";